import { Cart } from "@/components/Cart/Cart"
import { CartHeader } from "@/components/Cart/Header"
import { StyledCartContainer } from "@/components/Cart/StyledCart"
import { CartPageRecommends } from "@/components/LeadHit"
import { Meta } from "@/components/Meta/Meta"
import { Container, RowContentSidebar } from "@/styles/utils/StyledGrid"
import { TITLE_SITE_RU } from "@/utils/constants"

export default function CartPage(): JSX.Element {
  return (
    <>
      <Meta title={`Моя корзина - ${TITLE_SITE_RU}`} />
      <StyledCartContainer>
        <Container>
          <RowContentSidebar>
            <CartHeader />
            <Cart />
          </RowContentSidebar>

          <CartPageRecommends />
        </Container>
      </StyledCartContainer>
    </>
  )
}
